import { buildSearchRequestBody } from "@/utils/searchRequestBuilder.util";
import { useQuery } from "@tanstack/react-query";

import { SearchParams } from "@/hooks/api/search/useInfiniteSearch";
import useSalesyApiClient from "@/hooks/useSalesyApiClient";

export const useSelectAllSearch = (searchParams: SearchParams | undefined) => {
  const { apiClient } = useSalesyApiClient();

  return useQuery({
    queryKey: ["select-all-search", searchParams],
    queryFn: () => {
      const filter = buildSearchRequestBody(searchParams!);

      return apiClient.selectSearch.select({ requestBody: { filter } });
    },
    enabled: !!searchParams,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });
};
